import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import OpacityIcon from "@mui/icons-material/Opacity";
import SpeedIcon from "@mui/icons-material/Speed";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { FuelCellSummaryStats } from "../models/FuelCellRow";
import { KpiTile } from "@/components/layout/KpiTile";

interface Props {
  stats: FuelCellSummaryStats;
}

export function FuelCellSummary({ stats }: Props) {
  const { t } = useTranslation();
  const theme = useTheme();

  const fmtKg = (v: number) => `${v.toFixed(1)} kg`;
  const fmtPct = (v: number | null) => (v == null ? "—" : `${v.toFixed(1)} %`);

  return (
    <Stack direction="row" gap={1.5} flexWrap="wrap" sx={{ px: 2, flexShrink: 0 }}>
      <KpiTile
        label={t("fuelCell.summary.totalUsed", "Total used")}
        value={fmtKg(stats.totalUsedKg)}
        hint={t("fuelCell.summary.acrossVehicles", "Across {{count}} vehicles", {
          count: stats.deviceCount,
        })}
        icon={<SpeedIcon />}
        color={theme.palette.primary.main}
      />
      <KpiTile
        label={t("fuelCell.summary.totalRefills", "Refills")}
        value={String(stats.totalRefills)}
        hint={t("fuelCell.summary.inRange", "In selected range")}
        icon={<LocalGasStationIcon />}
        color={theme.palette.success.main}
      />
      <KpiTile
        label={t("fuelCell.summary.avgLevel", "Average level")}
        value={fmtPct(stats.avgLevelPercent)}
        hint={t("fuelCell.summary.currentSnapshot", "Current snapshot")}
        icon={<OpacityIcon />}
        color={theme.palette.info.main}
      />
      <KpiTile
        label={t("fuelCell.summary.lowFuel", "Low fuel")}
        value={String(stats.lowFuelCount)}
        hint={t("fuelCell.summary.below20", "Below 20 %")}
        icon={<WarningAmberIcon />}
        color={stats.lowFuelCount > 0 ? theme.palette.warning.main : theme.palette.text.secondary}
      />
    </Stack>
  );
}
